<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
      max-width="600"
      outlined
    >
      <v-card-title class="d-fluid justify-space-between ml-2 pa-2">
        {{ $t('app.status') }}<v-icon color="grey" class="" @click="$router.push({ path: '/help/1'})">mdi-information</v-icon>
      </v-card-title>
      <v-card outlined>
        <v-card-subtitle class="overline">{{ $t('home.risk') }}</v-card-subtitle>
        <v-card-text>
          <v-row @click="$router.push({ path: '/graph'})">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn v-if="getRiskLevelNum === 0" color="green" fab x-large>
                <v-icon x-large>mdi-emoticon-happy-outline</v-icon>
              </v-btn>
              <v-btn v-if="getRiskLevelNum === 1" color="orange" fab x-large>
                <v-icon x-large>mdi-emoticon-neutral-outline</v-icon>
              </v-btn>
              <v-btn  v-if="getRiskLevelNum === 2" color="red" fab x-large>
                <v-icon x-large>mdi-emoticon-sad-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined>
        <v-card-subtitle class="overline">{{ $t('home.healthStatus') }}</v-card-subtitle>
        <v-card-text>
          <v-row @click="$router.push({ path: '/settings'})">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn v-if="health === 0" color="green" fab small>
                <v-icon>mdi-emoticon-happy-outline</v-icon>
              </v-btn>
              <v-btn v-if="health === 1" color="orange" fab small>
                <v-icon>mdi-emoticon-neutral-outline</v-icon>
              </v-btn>
              <v-btn  v-if="health === 2" color="red" fab small>
                <v-icon>mdi-emoticon-sad-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined>
        <v-card-subtitle class="overline">{{ $t('home.persons') }}</v-card-subtitle>
        <v-card-text>
          <v-row justify="center" @click="$router.push({ path: '/connections'})">
            <v-avatar v-if="getPersonsRisk.ok > 0" left class="green mx-2" size="30">{{ getPersonsRisk.ok }}</v-avatar>
            <v-avatar v-if="getPersonsRisk.med > 0" left class="orange mx-2" size="30">{{ getPersonsRisk.med }}</v-avatar>
            <v-avatar v-if="getPersonsRisk.high > 0" left class="red mx-2" size="30">{{ getPersonsRisk.high }}</v-avatar>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
  },
  data: () => ({
    dialogEditPersonConnection: false,
    valid: false,
    formData: {
      pid: '',
      desc: '',
      type: 0,
    },
    descriptionRules: [
      v => v.length <= 100 || 'Popis by měl mít méně než 100 znaků',
    ]
  }),
  computed: {
      locationsRisk: function() {
        return {ok: 0, med: 0, high: 0}
      },
      ...mapGetters(['sortedPersonConnections', 'risk', 'health', 'currentHealthStatus', 'getRiskLevel', 'getRiskLevelNum', 'getRiskColor', 'getPersonsRisk'])
  },
  mounted() {
  },
  methods: {
    updateHealth() {
      this.$store.commit('updateHealth', this.health)
      this.$emit('toSynchronize')
    }
  }
}
</script>
